import React from "react";

import { CycleContainer as CycleContainerComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

interface CycleContainerProps {
    isInsideModal?: boolean;
    subDimensionsData?: any;
    id?: string; //this prop allows ProgressScore component to scroll down to specific CycleContainer
}

const CycleContainer: React.FC<CycleContainerProps> = ({
    isInsideModal,
    subDimensionsData,
    id,
}) => {
    const { cycleContainerData, isFetchingCycleContainer, isErrorCycleContainer } =
        useSessionDetailsContext();

    const isEmptyState = () => {
        if (isInsideModal) {
            return (
                !subDimensionsData ||
                (Array.isArray(subDimensionsData) && subDimensionsData?.length === 0)
            );
        } else if (
            !isErrorCycleContainer &&
            (!cycleContainerData || cycleContainerData?.length === 0)
        ) {
            return true;
        }
    };

    if (isFetchingCycleContainer) {
        return <ContentLoader height="43.125rem" />;
    }

    if (!subDimensionsData && isErrorCycleContainer && !isFetchingCycleContainer) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="40.125rem"
                />
            </ComponentWrapper>
        );
    }

    if (isEmptyState()) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-details:cycle-container:empty-state:title"
                    emptyStateType={EmptyStateType.Charts}
                    minHeight="40.125rem"
                />
            </ComponentWrapper>
        );
    }

    return (
        <CycleContainerComponent
            title={isInsideModal ? subDimensionsData.title : cycleContainerData.title}
            cyclesData={
                isInsideModal ? subDimensionsData.cyclesData : cycleContainerData.cyclesData
            }
            targetedStat={
                isInsideModal ? subDimensionsData.targetedStat : cycleContainerData.targetedStat
            }
            id={id}
        />
    );
};

export default CycleContainer;
